// extracted by mini-css-extract-plugin
export default {"settingsSectionHeader":"style_settingsSectionHeader__bU3PP","l1":"style_l1__qKBp7","wrapper":"style_wrapper__qgRaf","showHideToggle":"style_showHideToggle__t2J7Q"};